"use strict";

var SILK_RIBBON = 'Silk Ribbon Spools';
var WAX_SEALS = 'Wax Seals';
var VELLUM_JACKETS = 'Vellum Jackets';
module.exports = {
  SILK_RIBBON: SILK_RIBBON,
  WAX_SEALS: WAX_SEALS,
  VELLUM_JACKETS: VELLUM_JACKETS
};